import type { Recipe } from '../../types'
import { image, ingredient, section } from '../helpers'

export const pestoPistaches: Recipe = {
  slug: 'pesto-pistaches',
  title: 'Pesto de pistaches',
  category: 'salé',
  description: 'Un pesto crémeux, légèrement granuleux, où la pistache reste dominante.',
  image: image('pesto-pistaches'),
  tags: ['pistache', 'sauce', 'parmesan'],
  meta: [{ label: 'Préparation', value: '10 min' }],
  sections: [
    section('Ingrédients', [
      ingredient('pistaches', 'pistaches', '100 g de pistaches décortiquées non salées', {
        amount: 100,
        unit: 'g',
        shoppingKey: 'pistaches',
      }),
      ingredient('fromage', 'parmesan ou pecorino', '35 à 40 g de parmesan ou de pecorino', {
        amount: 35,
        unit: 'g',
        shoppingKey: 'parmesan',
      }),
      ingredient('huile', 'huile d’olive', '60 à 80 g d’huile d’olive', {
        amount: 60,
        unit: 'g',
        shoppingKey: 'huile d’olive',
      }),
      ingredient(
        'basilic',
        'basilic',
        '2 petites feuilles de basilic, facultatives — pas davantage, pour garder la pistache dominante',
        { optional: true, shoppingKey: 'basilic' },
      ),
      ingredient('eau', 'eau', '1 c. à café d’eau, facultative', { optional: true, shoppingKey: 'eau' }),
      ingredient('citron', 'jus de citron', '1 c. à café de jus de citron', { shoppingKey: 'citron' }),
      ingredient('assaisonnement', 'sel et poivre', 'Sel et poivre'),
    ]),
  ],
  steps: [
    'Mixer d’abord les pistaches seules, par impulsions courtes, jusqu’à obtenir des morceaux d’environ 1 à 2 mm. Ne pas mixer plus finement.',
    'Ajouter le fromage et le basilic ciselé si vous l’utilisez, puis mélanger avec une cuillère.',
    'Verser progressivement 50 g d’huile d’olive tout en mélangeant. Ajouter ensuite un peu d’huile, jusqu’à 80 g, selon la consistance souhaitée.',
    'Ajouter le jus de citron, saler légèrement et poivrer. Détendre avec une cuillère à café d’eau si nécessaire.',
    'Goûter et rectifier l’assaisonnement. Le pesto doit rester crémeux mais légèrement granuleux, sans devenir une purée complètement lisse.',
  ],
  note: 'Le point clé est la texture : procéder par impulsions et s’arrêter tant que les éclats de pistache mesurent encore environ 1 à 2 mm.',
}
